// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.9%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PureHD Navbar Styles */

/* Main Header */
.portal-header {
  background-color: #4D64C1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  position: sticky;
  top: 0;
  z-index: 1030;
}

/* Utility Bar - Top Section */
.utility-bar {
  background-color: rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 10px 0;
  font-size: 1rem;
}

.utility-bar .welcome-message {
  color: #ffffff;
  font-weight: 500;
}

.utility-bar .welcome-message i {
  color: rgba(255, 255, 255, 0.8);
}

.utility-links {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}

.utility-link {
  color: #ffffff !important;
  text-decoration: none;
  font-weight: 400;
  transition: all 0.2s ease;
  padding: 0.25rem 0;
  border: none !important;
  background: none !important;
  cursor: pointer;
}

.utility-link:hover {
  color: rgba(255, 255, 255, 0.7) !important;
}

.utility-link i {
  color: rgba(255, 255, 255, 0.8);
  margin-right: 0.25rem;
  transition: color 0.2s ease;
}

.utility-link:hover i {
  color: rgba(255, 255, 255, 0.7);
}

/* Main Navigation */
.portal-header .navbar {
  padding: 1rem 0;
  background-color: transparent;
}

.portal-header .navbar-brand {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  text-decoration: none;
  margin-right: 2rem;
}

.portal-header .logo-container {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.portal-header .navbar-brand img {
  height: 80px;
  width: auto;
  display: block;
  max-width: 100%;
}

.portal-header .logo-text {
  font-size: 1.4rem;
  font-weight: 500;
  color: #ffffff;
  margin: 0;
  opacity: 0.9;
  white-space: nowrap;
}

/* Navigation Links */
.portal-header .main-nav {
  gap: 0.5rem;
}

.portal-header .main-nav .nav-item {
  position: relative;
}

.portal-header .main-nav .nav-link {
  color: #ffffff !important;
  font-weight: 500;
  font-size: 1.1rem;
  padding: 0.75rem 1.25rem;
  transition: all 0.3s ease;
  text-decoration: none;
  border-radius: 6px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.portal-header .main-nav .nav-link i {
  font-size: 1.2rem;
  color: #ffffff;
  opacity: 0.9;
  transition: opacity 0.3s ease;
}

.portal-header .main-nav .nav-link:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: #ffffff !important;
}

.portal-header .main-nav .nav-link:hover i {
  opacity: 1;
}

/* Active State */
.portal-header .main-nav .nav-link.active {
  background-color: rgba(0, 0, 0, 0.2);
  color: #ffffff !important;
}

.portal-header .main-nav .nav-link.active i {
  color: #ffffff;
  opacity: 1;
}

/* Mobile Toggle Button */
.portal-header .navbar-toggler {
  border: 2px solid rgba(255, 255, 255, 0.5);
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
}

.portal-header .navbar-toggler:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.25);
}

.portal-header .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 1.25rem;
  height: 1.25rem;
}

/* Cart Badge */
.cart-badge {
  position: absolute;
  top: -0.25rem;
  right: -0.5rem;
  background-color: #dc3545;
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.125rem 0.375rem;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Responsive Styles */
@media (max-width: 991.98px) {
  .portal-header .navbar-collapse {
    background-color: #4D64C1;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    margin-top: 1rem;
    padding: 1rem 0;
  }

  .portal-header .main-nav {
    gap: 0;
  }

  .portal-header .main-nav .nav-link {
    padding: 0.75rem 1rem;
    border-radius: 0;
  }

  .portal-header .main-nav .nav-link:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  .portal-header .main-nav .nav-link.active {
    background-color: rgba(0, 0, 0, 0.2);
    color: #ffffff !important;
  }
}

@media (max-width: 575.98px) {
  .utility-bar {
    font-size: 0.8rem;
    padding: 6px 0;
  }

  .utility-links {
    gap: 1rem;
  }

  .portal-header .navbar-brand img {
    height: 60px;
  }

  .portal-header .logo-text {
    font-size: 1.1rem;
  }
}

/* Remove any conflicting styles from other CSS files */
.portal-header .btn-link {
  text-decoration: none !important;
}

/* Ensure proper contrast for all text */
.portal-header * {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Ensure our styles take precedence over theme.css */
.portal-header,
.portal-header .navbar {
  background-color: #4D64C1 !important;
}

.portal-header .navbar-brand,
.portal-header .navbar-nav .nav-link {
  color: #ffffff !important;
}

/* Fix for utility bar text colors */
.utility-bar {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.utility-bar * {
  color: #ffffff !important;
}

.utility-bar .utility-link {
  color: #ffffff !important;
}

.utility-bar .utility-link:hover {
  color: rgba(255, 255, 255, 0.7) !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/navbar.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB,gBAAgB;AAChB;EACE,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,oCAAoC;EACpC,iDAAiD;EACjD,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,yDAAkQ;EAClQ,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE;IACE,yBAAyB;IACzB,8CAA8C;IAC9C,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,MAAM;EACR;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,uDAAuD;AACvD;EACE,gCAAgC;AAClC;;AAEA,wCAAwC;AACxC;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,qDAAqD;AACrD;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":["/* PureHD Navbar Styles */\n\n/* Main Header */\n.portal-header {\n  background-color: #4D64C1;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  position: sticky;\n  top: 0;\n  z-index: 1030;\n}\n\n/* Utility Bar - Top Section */\n.utility-bar {\n  background-color: rgba(0, 0, 0, 0.1);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 10px 0;\n  font-size: 1rem;\n}\n\n.utility-bar .welcome-message {\n  color: #ffffff;\n  font-weight: 500;\n}\n\n.utility-bar .welcome-message i {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.utility-links {\n  display: flex;\n  gap: 1.5rem;\n  align-items: center;\n}\n\n.utility-link {\n  color: #ffffff !important;\n  text-decoration: none;\n  font-weight: 400;\n  transition: all 0.2s ease;\n  padding: 0.25rem 0;\n  border: none !important;\n  background: none !important;\n  cursor: pointer;\n}\n\n.utility-link:hover {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\n.utility-link i {\n  color: rgba(255, 255, 255, 0.8);\n  margin-right: 0.25rem;\n  transition: color 0.2s ease;\n}\n\n.utility-link:hover i {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n/* Main Navigation */\n.portal-header .navbar {\n  padding: 1rem 0;\n  background-color: transparent;\n}\n\n.portal-header .navbar-brand {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  text-decoration: none;\n  margin-right: 2rem;\n}\n\n.portal-header .logo-container {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.portal-header .navbar-brand img {\n  height: 80px;\n  width: auto;\n  display: block;\n  max-width: 100%;\n}\n\n.portal-header .logo-text {\n  font-size: 1.4rem;\n  font-weight: 500;\n  color: #ffffff;\n  margin: 0;\n  opacity: 0.9;\n  white-space: nowrap;\n}\n\n/* Navigation Links */\n.portal-header .main-nav {\n  gap: 0.5rem;\n}\n\n.portal-header .main-nav .nav-item {\n  position: relative;\n}\n\n.portal-header .main-nav .nav-link {\n  color: #ffffff !important;\n  font-weight: 500;\n  font-size: 1.1rem;\n  padding: 0.75rem 1.25rem;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  border-radius: 6px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.portal-header .main-nav .nav-link i {\n  font-size: 1.2rem;\n  color: #ffffff;\n  opacity: 0.9;\n  transition: opacity 0.3s ease;\n}\n\n.portal-header .main-nav .nav-link:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #ffffff !important;\n}\n\n.portal-header .main-nav .nav-link:hover i {\n  opacity: 1;\n}\n\n/* Active State */\n.portal-header .main-nav .nav-link.active {\n  background-color: rgba(0, 0, 0, 0.2);\n  color: #ffffff !important;\n}\n\n.portal-header .main-nav .nav-link.active i {\n  color: #ffffff;\n  opacity: 1;\n}\n\n/* Mobile Toggle Button */\n.portal-header .navbar-toggler {\n  border: 2px solid rgba(255, 255, 255, 0.5);\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n}\n\n.portal-header .navbar-toggler:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.25);\n}\n\n.portal-header .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.9%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n/* Cart Badge */\n.cart-badge {\n  position: absolute;\n  top: -0.25rem;\n  right: -0.5rem;\n  background-color: #dc3545;\n  color: white;\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 0.125rem 0.375rem;\n  border-radius: 10px;\n  min-width: 18px;\n  text-align: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n/* Responsive Styles */\n@media (max-width: 991.98px) {\n  .portal-header .navbar-collapse {\n    background-color: #4D64C1;\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n    margin-top: 1rem;\n    padding: 1rem 0;\n  }\n\n  .portal-header .main-nav {\n    gap: 0;\n  }\n\n  .portal-header .main-nav .nav-link {\n    padding: 0.75rem 1rem;\n    border-radius: 0;\n  }\n\n  .portal-header .main-nav .nav-link:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n  }\n\n  .portal-header .main-nav .nav-link.active {\n    background-color: rgba(0, 0, 0, 0.2);\n    color: #ffffff !important;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .utility-bar {\n    font-size: 0.8rem;\n    padding: 6px 0;\n  }\n\n  .utility-links {\n    gap: 1rem;\n  }\n\n  .portal-header .navbar-brand img {\n    height: 60px;\n  }\n\n  .portal-header .logo-text {\n    font-size: 1.1rem;\n  }\n}\n\n/* Remove any conflicting styles from other CSS files */\n.portal-header .btn-link {\n  text-decoration: none !important;\n}\n\n/* Ensure proper contrast for all text */\n.portal-header * {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Ensure our styles take precedence over theme.css */\n.portal-header,\n.portal-header .navbar {\n  background-color: #4D64C1 !important;\n}\n\n.portal-header .navbar-brand,\n.portal-header .navbar-nav .nav-link {\n  color: #ffffff !important;\n}\n\n/* Fix for utility bar text colors */\n.utility-bar {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n\n.utility-bar * {\n  color: #ffffff !important;\n}\n\n.utility-bar .utility-link {\n  color: #ffffff !important;\n}\n\n.utility-bar .utility-link:hover {\n  color: rgba(255, 255, 255, 0.7) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
